<template>
  <b-container class="create">
    <b-form @submit.prevent="submit">
      <div class="float-right">
        <b-button variant="default" @click="cancel">Cancel</b-button>
        <b-button variant="info" type="submit">
          <template v-if="!saveLoading">Save</template>
          <template v-else>
            <b-spinner small />
            <span>Saving...</span>
          </template>
        </b-button>
      </div>

      <v-wait :for="loaderId">
        <template slot="waiting">
          <HalfCircleSpinner />
          <div class="spinner-message my-3 text-center">
            Loading society data...
          </div>
        </template>
        <h2 class=" v2_font_size_28 v2_color_black">
          Society Certifying Boards: {{ title }}
        </h2>
        <b-row class="my-2">
          <b-col>
            <b-form-group label="Certifying Boards:">
              <b-form-checkbox-group
                v-model="selected"
                :options="certifyingBoardOptions"
                stacked
              />
            </b-form-group>
          </b-col>
        </b-row>
      </v-wait>
    </b-form>
  </b-container>
</template>

<script>
  import {GET_CERTIFYING_BOARDS_ACTION} from "@/store/certifyingBoards";
  import {handleServerErrorWithValidation} from "@/helpers/ToastedHelper";
  import Api from "@/providers/Api";
  import { HalfCircleSpinner } from 'epic-spinners';

  export default {
    name: "SocietyCertifyingBoards",
    components: {
      HalfCircleSpinner,
    },
    data: function () {
      return {
        saveLoading: false,
        society: null,
        selected: [],
      };
    },
    created: function () {
      this.uploadData();
    },
    computed: {
      loaderId: function () {
        return `loading_${this.$options.name}`;
      },
      title: function () {
        return this.society ? this.society.name : '';
      },
      certifyingBoardOptions: function () {
        return this.$store.state.certifyingBoards.items.map((c) => ({
          value: c.id,
          text: c.title,
        }));
      },
    },
    methods: {
      uploadData: async function () {
        try {
          this.$wait.start(this.loaderId);
          await this.$store.dispatch(GET_CERTIFYING_BOARDS_ACTION);
          this.society = await Api.getSociety(this, this.$route.params.societyId);
          this.society && this.society.certifyingBoards && this.society.certifyingBoards.map(c => {
            this.selected.push(c.id);
          });
        } catch (error) {
          handleServerErrorWithValidation(error, this.$toasted);
        } finally {
          this.$wait.end(this.loaderId);
        }
      },
      submit: async function () {
        this.saveLoading = true;
        try {
          await Api.updateSocietyCertifyingBoards(
            this.society.id,
            this.selected
          );
        } catch (error) {
          handleServerErrorWithValidation(error, this.$toasted);
        } finally {
          this.saveLoading = false;
        }
      },
      cancel: function () {
        this.$router.go(-1);
      },
    },
  }
</script>

<style scoped>

</style>
